import React from "react";
import Logo from "../img/transparentLogo.png"
import { Button } from "antd";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default custom-navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <img src={Logo} alt="Logo" height={100} width={100} className="nav-logo" />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse nav-custom"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/* An absolute URL on purpose: this app has one page and no route
                of its own for /browse. The nav styles in App.css pick it up
                like any other item. */}
            <li>
              <a href="https://search.searten.com/browse">
                Browse
              </a>
            </li>
            <li>
              <a href="http://app.searten.com">
                Login
              </a>
            </li>
            {/* <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};
